import getSupportedNetworks from '../helpers/get-supported-networks';
import checkoutForButtonless from './buttonless-wrappers/checkout-for-buttonless';
import completeIdentityValidationForButtonless from './buttonless-wrappers/complete-identity-validation-for-buttonless';
import getSrcProfileForButtonless from './buttonless-wrappers/get-src-profile-for-buttonless';
import identityLookupForButtonless from './buttonless-wrappers/identity-lookup-for-buttonless';
import initiateIdentityValidationForButtonless from './buttonless-wrappers/initiate-identity-validation-for-buttonless';
import isRecognizedForButtonless from './buttonless-wrappers/is-recognized-for-buttonless';
import unbindAppInstanceForButtonless from './buttonless-wrappers/unbind-app-instance-for-buttonless';
import init from './init';
import reinitializeOrchSdk from './reinitialize-orch-sdk';
import setSrcWindowReference from './set-src-window-reference';
/**
 * Visa VsbOrchAdapter Adapter
 * NOTE: initialization and init/isRecognized are done as part of init() call now
 * @param {object} configs
 * @param {boolean} isInteropEligible
 * @returns {instance}
 */
function VsbOrchAdapter() {
  if (typeof VsbOrchAdapter.instance === 'object') {
    return VsbOrchAdapter.instance;
  }
  //TODO - Demo consts
  VsbOrchAdapter.instance = this;
}
/**
 * Visa Orchestration Adapter
 *  - The OrchAdapter is the interface to communicate with all SDKs [Visa/MC/Amex]
 *    * This layer will be taking main role in INO context
 *    * TODO We will be adding unit test scripts in upcoming sprints
 */
VsbOrchAdapter.prototype = {
  init,
  reinitializeOrchSdk,
  setSrcWindowReference
};

const namespace = 'V';
window[namespace] = Object.assign({}, window[namespace], {
  checkout: checkoutForButtonless,
  completeIdentityValidation: completeIdentityValidationForButtonless,
  getSrcProfile: getSrcProfileForButtonless,
  getSupportedNetworks,
  identityLookup: identityLookupForButtonless,
  initiateIdentityValidation: initiateIdentityValidationForButtonless,
  isRecognized: isRecognizedForButtonless,
  unbindAppInstance: unbindAppInstanceForButtonless
});

export default VsbOrchAdapter;
